import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PlanCardProps {
  name: string;
  tagline: string;
  features: string[];
  cta: ReactNode;
  badge?: string;
  highlighted?: boolean;
  /** Toggle + price block, rendered between the header and the feature list. */
  children: ReactNode;
}

const PlanCard = ({
  name,
  tagline,
  features,
  cta,
  badge,
  highlighted = false,
  children,
}: PlanCardProps) => (
  <div
    className={cn(
      "relative flex flex-col gap-6 rounded-3xl bg-card transition-shadow duration-300",
      highlighted
        ? "border-2 border-accent p-[31px] shadow-lg shadow-accent/20 hover:shadow-xl hover:shadow-accent/30"
        : "border border-border p-8 hover:shadow-xl hover:shadow-foreground/5",
    )}
  >
    {badge && (
      <span className="absolute -top-[13px] left-8 rounded-full bg-accent px-3.5 py-[5px] text-xs font-bold text-accent-foreground shadow-md shadow-accent/40">
        {badge}
      </span>
    )}

    <div className="flex flex-col gap-2">
      <h3 className="font-heading text-2xl font-bold">{name}</h3>
      <p className="text-sm leading-normal text-muted-foreground">{tagline}</p>
    </div>

    {children}

    <ul className="flex flex-col gap-2.5 text-sm text-foreground/90">
      {features.map((feature) => (
        <li key={feature} className="flex gap-2.5">
          <span aria-hidden="true" className="font-bold text-[#F0C419]">
            ✓
          </span>
          {feature}
        </li>
      ))}
    </ul>

    {cta}
  </div>
);

export default PlanCard;
